<template>
  <div class="dataBoard">
    <basic-container>

      <el-form :inline="true"
               :model="formInline"
               class="formInline">

        <el-form-item label="虚拟事件名称"
                      style="margin: 0 160px 0 40px;">
          <el-input v-model="formInline.name"
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="()=>{
          formInline = { name: '', dash_type: 'public' }
          handleSearch()
          }"
                     style="padding: 12px 40px ;">重置</el-button>
          <el-button type="primary"
                     :loading="loadingSearch"
                     style="padding: 12px 40px ;"
                     @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>

    </basic-container>
    <basic-container>
      <div>
        <el-button type="primary" @click="handleAdd"
                   style="padding: 12px 40px ; margin-left: 8px;">新增虚拟事件</el-button>
      </div>

      <avue-crud class="table"
                v-loading="loadingSearch"
                 ref="crud"
                 :option="option"
                 :page.sync="page"
                 :table-loading="loading"
                 @on-load="getList"
                 :data="data">

        <template slot-scope="scope"
                  slot="name">
          <span style="color: #5b93fc; cursor: pointer;"
                @click="handleEdit(scope.row)"> {{scope.row.name}} </span>
        </template>

        <template slot-scope="scope"
                  slot="menu">

          <el-button size="small"
                     style="color: #F16A6A;"
                     type="text"
                     @click="handleDeleteRow(scope.row)">删除</el-button>
          <el-button size="small"
                     @click="handleEdit(scope.row)"
                     type="text">编辑</el-button>
        </template>
      </avue-crud>

    </basic-container>
    <addDialog ref="addDialog" @getList="updateList" />
  </div>

</template>

<script>
import options from './option';
import addDialog from "./addDialog.vue";
import { virtual_event_list, virtual_event_delete,virtual_event_quote_check } from '@/api/bigData';
import { merge } from '@/util/common';
export default {
  components: {
    addDialog,
  },
  data () {
    return {
      loadingSearch: false,
      userid: '',
      option: {},
      loading: false,
      data: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      formInline: {
        name: '',
        dash_type: 'public'
      }
    }
  },
  created () {

    try {
      this.userid = JSON.parse(window.localStorage.getItem('lebo-userInfo')).content.user_id
    } catch (e) { console.log(e) }
    this.option = options(this);
  },
  methods: {
    updateList(){
      setTimeout(() => {
        this.getList()
      }, 1000)
    },
    // 新增
    handleAdd(){
      // 需要清空数据
      this.$refs.addDialog.dialogVisible = true;
      this.$refs.addDialog.getDetail()
      
    },
    // 编辑
    handleEdit (row) {
      console.log('row',row)
      this.handleAdd()
      this.$refs.addDialog.getDetail(row.id)
    },
    handleSearch () {
      this.page.currentPage = 1;
      this.getList();
    },
  async  handleDeleteRow (row) {

    const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });

      //删除前先调接口 virtual_event_quote_check 确认是删除影响
    let res = await  virtual_event_quote_check({ id: row.id })
    loading.close();
    console.log('res-----',res)
  
    const h = this.$createElement;
    let view = [ h('div', { style: 'padding: 0 0 30px 0' }, `虚拟事件[${row.name ||  '-暂无-'}] 正在被以下报表引用，请确认修改报表后删除。 `)]

    if(res.status==200){
      let list = JSON.parse(res.data) || []
      if(list.length){
        list.forEach(element => {
        view.push( h('div', { style: 'text-align: center' }, element.name))
      });
      }else{
        view.push( h('div', { style: 'text-align: center' }, '-暂无-'))
      }
     
    }
        this.$msgbox({
          title: '消息',
          message: h('p', null, view),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
            const res = await  virtual_event_delete({ id: row.id })
            if (res.status === 200) {
                this.$message({
                  message: `删除成功！`,
                  type: 'success'
                });
                instance.confirmButtonLoading = false;
                done()
                this.getList();
            }else{
              instance.confirmButtonLoading = false;
              done()
            }
            } else {
              done()
            }
          }
        }).then(action => {
          console.log('action', action)
        }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getList () {


      let params = {
        lk_name: this.formInline.name,
      }
      const query = merge({}, params, {
        pagenum: this.page.currentPage,
        pagesize: this.page.pageSize
      });
      this.loadingSearch = true
      virtual_event_list(query).then(res => {
        this.loadingSearch = false
        console.log('virtual_event_list------', res)
        if (res.status === 200) {
          const data = JSON.parse( res.data);
          this.data = data.data;
          this.page.total = data.total;
        }
      }).catch(() => {
        this.loadingSearch = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.formInline {
  margin-top: 10px;
  height: 50px;
}
.table {
  margin-top: 16px;
}
</style>